type Props = {
  label: string;
  sortKey: string;
  activeKey: string | null;
  sortDir: "asc" | "desc";
  onToggle: (key: string) => void;
};

export function SortHeader({ label, sortKey, activeKey, sortDir, onToggle }: Props) {
  const active = activeKey === sortKey;
  return (
    <button
      type="button"
      className={active ? "tbl-sort is-active" : "tbl-sort"}
      aria-sort={active ? (sortDir === "asc" ? "ascending" : "descending") : "none"}
      data-sort={sortKey}
      onClick={() => onToggle(sortKey)}
    >
      <span>{label}</span>
      <span className="tbl-sort__icon" aria-hidden="true">
        {!active ? "↕" : sortDir === "asc" ? "↑" : "↓"}
      </span>
    </button>
  );
}
